import React from 'react'

import styles from './PillButton.module.scss'

export type PillButtonVariant = 'primary' | 'danger' | 'outlined' | 'muted' | 'toggle'

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: PillButtonVariant
  active?: boolean
  size?: 'sm' | 'md'
}

/**
 * Unified pill button for all onboarding V2 modules.
 *
 * Variants:
 * - `primary` — blue filled (approve, confirm)
 * - `danger` — red filled (reject, cancel)
 * - `outlined` — white with border, blue hover (secondary actions)
 * - `muted` — gray border, quiet (admin/low-frequency actions)
 * - `toggle` — filter toggle with active state
 *
 * Sizes:
 * - `sm` — compact (3px 10px padding) for inline quick actions
 * - `md` — standard (5px 14px padding) for action bars
 */
export const PillButton = React.forwardRef<HTMLButtonElement, IProps>(
  ({ variant = 'outlined', active = false, size = 'md', className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={`${styles.pill} ${styles[`pill--${variant}`]} ${styles[`pill--${size}`]} ${active ? styles['pill--active'] : ''} ${className || ''}`}
      {...props}
    >
      {children}
    </button>
  )
)

PillButton.displayName = 'PillButton'
